import React from "react";
import { EnquiryInfoItem } from "venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfoItem";
import dayjs from "dayjs";

export function DateEnquiryInfo({ value }) {
  return <EnquiryInfoItem title="Date" value={getDateRange(value)} />;
}

export function TimeEnquiryInfo({ value }) {
  return <EnquiryInfoItem title="Time" value={getTimeRange(value)} />;
}

function getTimeRange(dates) {
  return (
    dayjs(dates.from).format("HH:mm") + " - " + dayjs(dates.to).format("HH:mm")
  );
}

function getDateRange(dates) {
  return dayjs(dates.from).format("D/M/YYYY") ===
    dayjs(dates.to).format("D/M/YYYY")
    ? dayjs(dates.from).format("D/M/YYYY")
    : `${dayjs(dates.from).format("D")} - ${dayjs(dates.to).format(
        "D/M/YYYY"
      )}`;
}
